"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optionIdValidator = optionIdValidator;
exports.optionsValidator = optionsValidator;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function requiredOptionsValidator(props, propName, componentName) {
  var options = props.options;

  if (!Array.isArray(options) || options.length !== 2) {
    return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(componentName, "`, expected an array with exactly two option values. Validation failed."));
  }

  _propTypes.default.checkPropTypes({
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string.isRequired,
      text: _propTypes.default.string
    })).isRequired
  }, props, propName, componentName);

  return null;
}
/**
 * Must be a two element array where each element is a valid option.
 */


function optionsValidator(props, propName, componentName) {
  if (process.env.NODE_ENV !== 'production') {
    var options = props[propName];

    if (options === null || options === undefined) {
      return null;
    }

    return requiredOptionsValidator(props, propName, componentName);
  }

  return null;
}

optionsValidator.isRequired = requiredOptionsValidator;

function idInOptions(id, options) {
  return !!options.find(function (_ref) {
    var optionId = _ref.id;
    return id === optionId;
  });
}
/**
 * If provided, must be an ID in the options.
 */


function optionIdValidator(props, propName, componentName) {
  if (process.env.NODE_ENV !== 'production') {
    var defaultSelected = props.defaultSelected,
        options = props.options,
        selected = props.selected,
        current = props[propName];

    if (current && !idInOptions(current, options)) {
      return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(componentName, "`. The value of `").concat(propName, "` must be the ID of an option. Validation failed."));
    }

    if (defaultSelected && selected) {
      return new Error("Both `defaultSelected` and `selected` values are supplied to `".concat(componentName, "`. `defaultSelected` will not be used. Validation failed."));
    }
  }

  return null;
}